const urlParams = new URLSearchParams(window.location.search);

export default urlParams;